import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { DeviceTypeHelper } from '../../common/device-type-helper';
import { ApplicationConfig } from '../../config/config';
import { ContentFooterInfo } from '../../model/content/contentfooter.model';
import {
  ContentSecondaryChildPage,
  ContentSecondaryMainNavigation
} from '../../model/content/contentsecondarynavigation.model';
import { AdobeDataLayerService } from '../../services/adobe-data-layer/adobe-data-layer';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
@Component({
  selector: 'ngc-app-sec-links-content',
  templateUrl: 'app-secondary-links-content.component.html'
})
export class AppSecondaryLinksContentComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() navbarSecondaryLink: any;
  linkType: any;
  secondNavImage: any = '';
  secondNavImageAlt: any;
  public arrayOfNavigationKeys;
  public arrayOfChildKeys;
  public contentSecondNav: ContentSecondaryMainNavigation[];
  public contentChild: ContentSecondaryChildPage[];
  public deviceTypes: any = [];
  public externalImgUrl: ContentFooterInfo;
  public externalImgDesc: ContentFooterInfo;
  contentServiceHeaderFooterSubscribe: Subscription;
  deviceTypeSubscribe: Subscription;
  isAppNavLinksMob: boolean;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private cdf: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private srv: CommonService,
    private datalayer: DataLayer,
    private _deviceTypeHelper: DeviceTypeHelper,
    private appconfig: ApplicationConfig,
    private loggingService: LoggingService,
    private analytics: AdobeDataLayerService
  ) {}

  ngOnInit() {
    this.updateContent();
    if (this.appconfig.onBrowser) {
      this.deviceTypeSubscribe = this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
        });
    }
    this.getSecondNavImage();
    this.isAppNavLinksMob = window.innerWidth < 992 ? true : false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateContent();
  }

  onKyePress(e) {
    if (e.keyCode === 40) {
      // down arrow
      e.preventDefault();
      if (e.target.parentElement.nextElementSibling != null) {
        e.target.parentElement.nextElementSibling.firstChild.focus();
      }
    }
    if (e.keyCode === 38) {
      // up arrow
      e.preventDefault();
      if (e.target.parentElement.nextElementSibling != null) {
        e.target.parentElement.previousElementSibling.firstChild.focus();
      }
    }
  }

  updateContent() {
    if (this.navbarSecondaryLink !== undefined) {
      this.linkType = this.navbarSecondaryLink;
    }
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                this.externalImgUrl = data.footer.info.externalImgPath;
                this.externalImgDesc = data.footer.info.footerExtDesc;
                if (this.linkType !== undefined) {
                  if (data.header.secondaryNavigation) {
                    if (this.linkType === 'secondarynav') {
                      this.contentSecondNav =
                        data.header.secondaryNavigation.get(
                          'secondarynav'
                        ).details.mainNavigation;
                      this.contentChild =
                        data.header.secondaryNavigation.get(
                          'secondarynav'
                        ).details.childpages;
                    } else if (this.linkType === 'sky-miles') {
                      this.contentSecondNav =
                        data.header.secondaryNavigation.get(
                          'sky-miles'
                        ).details.mainNavigation;
                      this.contentChild =
                        data.header.secondaryNavigation.get(
                          'sky-miles'
                        ).details.childpages;
                    } else if (this.linkType === 'more') {
                      this.contentSecondNav =
                        data.header.secondaryNavigation.get(
                          'more'
                        ).details.mainNavigation;
                      this.contentChild =
                        data.header.secondaryNavigation.get(
                          'more'
                        ).details.childpages;
                    }
                  }
                }
                this.cdf.detectChanges();
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
  }

  secondNavMouseOver(navItem) {
    this.secondNavImageAlt = navItem.altText;
    if (!this.deviceTypes.isMobile) {
      this.secondNavImage = navItem.imagePathDesktop;
    } else {
      this.secondNavImage = navItem.mobileImagePath;
    }
  }

  setTrackingObject(selectedItem, e, url: string) {
    this.datalayer.setTrackingObjectProp1(
      'header:' + selectedItem.text,
      e.target
    );
    this.analytics.appNavLinksAnalytics(this.linkType, selectedItem, url);
  }

  getSecondNavImage() {
    if (this.contentSecondNav && this.contentSecondNav.length > 0) {
      this.secondNavImageAlt = this.contentSecondNav[0].altText;
      if (!this.deviceTypes.isMobile) {
        this.secondNavImage = this.contentSecondNav[0].imagePathDesktop;
      } else {
        this.secondNavImage = this.contentSecondNav[0].mobileImagePath;
      }
    } else {
      this.secondNavImage = '';
    }
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    if (this.deviceTypeSubscribe) {
      this.deviceTypeSubscribe.unsubscribe();
    }
    this.cdf.detach();
  }
}
